class TimedMessage extends HTMLElement {
    constructor() {
      super();
      this.endTime = new Date();
      this.endTime.setHours(15, 0, 0, 0);
  
      this.timerElement = this.querySelector(".countdown");
      this.updateCountdown();
    }
  
    updateCountdown() {
      const update = () => {
        const now = new Date();
        const diff = this.endTime - now;
  
        if (diff <= 0) {
          return;
        }
  
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

        let minute_text = '';
        if (minutes === 1){
            minute_text = "minut"
        } else {
            minute_text = "minute"
        }
  
        if (minutes === 0 && hours > 1) {
            this.timerElement.textContent = `${hours} ore`;
        } else if(minutes > 0 && hours === 1) {
            this.timerElement.textContent = `o oră şi ${minutes} ${minute_text}`;
        } else if(minutes > 0 && hours === 0){
            this.timerElement.textContent = `${minutes} ${minute_text}`;
        } else {
            this.timerElement.textContent = `${hours} ore şi ${minutes} ${minute_text}`;
        }
      };
  
      update();
      this.interval = setInterval(update, 60000);
    }
  
    disconnectedCallback() {
      clearInterval(this.interval);
    }
  }
  
  customElements.define("custom-timed-message", TimedMessage);  